import { useEffect, useRef } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { Card } from '@leroy-merlin-br/backyard-react-ui'

import { Actions } from 'lmcv/redux/modules/coupon'

import { ListVouchers } from './components/ListVouchers'

const ExchangePage = () => {
  const dispatch = useDispatch()
  const { money, activated } = useSelector(state => state.coupon, shallowEqual)

  const wrapperRef = useRef(null)

  useEffect(() => {
    wrapperRef.current.scrollIntoView({
      block: 'start',
      behavior: 'smooth'
    })
  }, [])

  useEffect(() => {
    dispatch(Actions.getMoney(1, 'available', 15))
  }, [dispatch])

  useEffect(() => {
    dispatch(Actions.getActivated(1, 'money', 15))
  }, [dispatch])

  return (
    <Card title="Vale-compras" ref={wrapperRef}>
      <ListVouchers vouchers={money} vouchersActivated={activated} />
    </Card>
  )
}

export default ExchangePage
